import React from "react";
import { useTranslation } from "react-i18next";
// import { NavLink } from 'react-router-dom';
import ArrowLonRightIcon from "../svg/ArrowLongRightIcon";
import { useNavigate } from "react-router-dom";

interface CardInstallationProps {
  title: string;
  desc: string;
  demoCount: number | null;
  link: string;
  icon: React.ReactElement;
  smartDesc?: string;
  message?: string;
  serviceType?: "injection" | "offtake" | "bess";
  comingSoon?: boolean;
}

const CardInstallation: React.FC<CardInstallationProps> = ({
  title,
  icon,
  demoCount,
  smartDesc,
  desc,
  message,
  serviceType,
  comingSoon,
}) => {
  const { t } = useTranslation("InstallationLanding");
  const navigate = useNavigate();

  // Determine if the card should be disabled
  const isUnavailable = demoCount === null;

  // Apply 'opacity-50' class when the card is disabled
  const cardClassName = `p-8 rounded-lg border-[1px] border-base-200 dark:border-primary-800 bg-base-100 dark:bg-primary-900 flex flex-col ${
    isUnavailable ? "opacity-50" : ""
  }`;

  const handleStartNow = (e: React.MouseEvent) => {
    e.preventDefault();

    localStorage.removeItem("installationNumbers");
    localStorage.removeItem("selectedServices");
    localStorage.removeItem("formVolumes");
    localStorage.removeItem("lastContractPayload");
    localStorage.removeItem("billingInfo");
    localStorage.removeItem("pslData");
    localStorage.removeItem("pslFullData");
    localStorage.removeItem("requiresSeparateContracts");
    localStorage.removeItem("injectionFormData");
    localStorage.removeItem("offtakeFormData");
    localStorage.removeItem("addServiceFormData");
    localStorage.removeItem("contractOverview");

    if (serviceType === "injection") {
      navigate("/addservice?intent=inj");
    } else if (serviceType === "offtake") {
      navigate("/addservice?intent=off");
    } else if (serviceType === "bess") {
      navigate("/bess");
    } else {
      // Default navigation if no service type is specified
      navigate("/pv-curtailment");
    }
  };
  return (
    <div className={cardClassName}>
      <div className="mb-[1rem]">{icon}</div>
      <div className="flex gap-1 items-center font-semibold text-primary-600">
        <div className="inline-block dark:text-white text-lg ">
          <h3>{title}</h3>
        </div>
        <div className="p-1 text-xs">
          {demoCount !== null && (
            <div>
              <span className="px-3 py-1 bg-primary-100 dark:bg-primary-950 dark:text-primary-100 rounded-full text-xs">
                {demoCount}
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="mb-4 text-sm leading-6 items-center text-primary-400 dark:text-primary-300 flex-grow min-h-[50px]">
        {smartDesc && <p className="text-secondary-600 text-sm font-semibold">{smartDesc}</p>}
        {message && <p className="text-xs text-red-500 mt-1">{message}</p>}
        <p className="mt-[1rem]">{desc}</p>
      </div>

      <div className="flex items-center mt-4 mb-1 gap-4">
        <div>
          {comingSoon ? (
            <button
              className="px-[1.25rem] py-[0.53rem] bg-gray-400 text-sm text-white rounded-3xl font-semibold cursor-not-allowed"
              disabled
            >
              {t("comingSoon")}
            </button>
          ) : !isUnavailable ? (
            <button
              onClick={handleStartNow}
              className="px-[1.25rem] py-[0.53rem] bg-primary-600 dark:bg-primary-600 text-sm text-white rounded-3xl hover:bg-primary-700 dark:hover:bg-primary-700 font-semibold flex gap-2 transition-colors"
            >
              {t("startNow")} <ArrowLonRightIcon />
            </button>
          ) : (
            <button
              className="px-[1.25rem] py-[0.53rem] bg-gray-400 text-sm text-white rounded-3xl font-semibold cursor-not-allowed opacity-50"
              disabled
            >
              {t("notAvailable")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardInstallation;
